/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";

const LISTAR_MESA_TELEFONE = `/leads/common/mesa-telefone/listar-atendimentos-fila/v1`;

const fetchData = async () => {
  const response = await instance.get(LISTAR_MESA_TELEFONE);
  return response?.data?.data;
};

export function useReceberMesaTelefone() {
  const query = useQuery({
    queryFn: fetchData,
    queryKey: ["listar_mesa_telefone"],
    refetchOnWindowFocus: false,
  });
  return query;
}
